import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, Typography } from '@mui/material';

import CloseIcon from 'app/components/Icons/CloseIcon';
import { useDeletePayment } from 'app/utils/services/salaryServices';

import SuccessModal from '../SuccessModal';

import { closeBtn, dialogActions, dialogTitle, paperProps, title, deleteBtn } from './ClearModal.sx';

interface Props {
  open: boolean;
  userId: string;
  close: Dispatch<SetStateAction<boolean>>;
  headerText: string;
  refetchSalaryData: () => void;
}

const DeleteModal = (props: Props) => {
  const { open, close, headerText, refetchSalaryData, userId } = props;
  const [successModal, setSuccessModal] = useState(false);
  const deletePayment = useDeletePayment();

  const handleDeletePayment = () => {
    deletePayment.mutate(userId, {
      onSuccess: () => {
        refetchSalaryData();
        close(false);
        setSuccessModal(true);
      },
    });
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => close(false)}
      >
        <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
          <Typography sx={title}>{headerText}</Typography>
          <Button
            color={'tertiary'}
            onClick={() => {
              close(false);
            }}
            sx={closeBtn}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogActions sx={dialogActions}>
          <Button sx={deleteBtn} onClick={handleDeletePayment}>
            Sil
          </Button>
          <Button
            color={'secondary'}
            sx={{ ml: '0 !important' }}
            onClick={() => {
              close(false);
            }}
          >
            Ləğv et
          </Button>
        </DialogActions>
      </Dialog>
      <SuccessModal open={successModal} close={setSuccessModal} successText={'Əməkdaş siyahıdan uğurla silindi.'} />
    </>
  );
};

export default DeleteModal;
